import React from 'react';
import styles from './stockStyles'
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';

const SearchBar = ({ onChange, ticker, setSymbolFunction, fetchAll }) => {
    const {isMobile}=  useSelector(state=> state.appReducer);

    const keyPress = (e) => {
        if (e.keyCode === 13 && ticker !== "") {
            setSymbolFunction(ticker)
            fetchAll(ticker)
        }
    }
    return (
        <div>
            <input
                name="ticker"
                style={isMobile?styles.tickerInputMobile:  window.innerWidth <= 1380 ?  styles.tickerInputSmall: styles.tickerInput}
                value={ticker}
                placeholder="Stock Ticker"
                onChange={(e) => onChange(e.target.value.toUpperCase())}
                onKeyDown={(event) => keyPress(event)}
            />
            <Button
                variant="contained"
                style={styles.goButton}
                onClick={() => {
                    if(ticker !== ""){
                        setSymbolFunction(ticker)
                        fetchAll(ticker)
                    }
                 
                }}
            >
                Go
            </Button>
        </div>
    );
}
export default SearchBar


// WEBPACK FOOTER //
// ./src/Pages/Stock/searchBar.js